import svgUrl from "ni:svgr;AjqL50ZSq6UzZMW0KPyj67hlsMztEI8sk5l3wobaqVc";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiSourceSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9 2H3v12h9V5h-2a1 1 0 0 1-1-1V2Zm4 3L9 1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V5ZM5.146 7.646a.5.5 0 1 0 .708.708L7 7.207V12a.5.5 0 0 0 1 0V7.207l1.146 1.147a.5.5 0 1 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiSourceSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiSourceSIcon)";
}